<template>
  <div id="contenedor-opciones-insumos">
    <v-tooltip
      v-if="mixValidaScopesActions(2)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar()">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
    </v-tooltip>
    <v-tooltip
    v-if="mixValidaScopesActions(3)"
    top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="borrar()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>Borrar</span>
    </v-tooltip>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesInsumos',
  props: {
    insumo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-insumo', this.insumo);
    },
    borrar() {
      eventBus.$emit('eliminar-insumo', this.insumo);
    },
  },
};
</script>

<style lang="scss">

</style>
